export default __webpack_public_path__ + "static/media/hostgator.69eb2b3b.svg";